export const SHOP_LINKS = [
    {
        identifier: "shop",
        url: "/shop",
        label: "Shop",
    },
];
